import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: [],
  errors: null,
  isLoading: true,
  action_fields: [],
  group_fields: [],
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        data: action.payload,
        action_fields: action.payload.action_fields,
        group_fields: action.payload.group_fields,
        isLoading: false,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetDisplayFieldReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetDisplayFieldReducer
export {ActionTypes, InitialState, Reducer}
